import axios from 'axios';

const CASHFREE_GATEWAY_BASE = 'https://cs.fabbuilder.com/cs-app/cashfree';

export const esignApi = {
  signDocument: async (tenantId: string, formData: FormData) => {
    const response = await axios.post(
      `${CASHFREE_GATEWAY_BASE}/api/tenant/${tenantId}/esign/sign-document`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return response.data;
  },

  getStatus: async (tenantId: string, verificationId: string, live: boolean = true) => {
    const response = await axios.get(
      `${CASHFREE_GATEWAY_BASE}/api/tenant/${tenantId}/esign/status/${verificationId}`,
      { params: { live } },
    );
    return response.data;
  },
};
